import { ReactNode, useEffect, useState } from "react";
import Picker from "react-mobile-picker";

function renderOptions(options: readonly string[], selectedColor: string) {
  return options?.map((option) => (
    <Picker.Item key={option} value={option}>
      {({ selected }) => (
        <div
          className={
            selected ? `font-semibold ${selectedColor}` : "text-neutral-400"
          }
        >
          {option}
        </div>
      )}
    </Picker.Item>
  ));
}

type TCustomYearMonthPicker = {
  setYearMonth: (value: string) => void;
  yearMonthvalue: string;
  label?: string;
  monthRangeShow?: ReactNode;
  dropdownHeight?: string;
  dropdownShow?: string;
  stateEmpty?: boolean;
  mode?: string;
};

export default function CustomYearMonthPicker({
  yearMonthvalue,
  setYearMonth,
  label,
  monthRangeShow,
  dropdownHeight,
  dropdownShow,
  stateEmpty = true,
  mode = "add",
}: TCustomYearMonthPicker) {
  const [showPicker, setShowPicker] = useState(false);

  const currentYear = new Date().getFullYear().toString();
  const currentMonthIndex = new Date().getMonth();

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const currentMonthName = months[currentMonthIndex];

  const [year, setYear] = useState(
    yearMonthvalue
      ? { year: yearMonthvalue.split(" ")[1] }
      : { year: currentYear },
  );

  const [month, setMonth] = useState(
    yearMonthvalue
      ? { month: yearMonthvalue.split(" ")[0] }
      : { month: currentMonthName },
  );

  const togglePicker = () => {
    setShowPicker(!showPicker);
  };

  const handleCloseModal = () => {
    setShowPicker(false);
    if (stateEmpty) {
      if (mode == "add") {
        setYearMonth("");
        setYear({ year: currentYear });
        setMonth({ month: currentMonthName });
      }
    }
  };

  const handldSetYearMonth = () => {
    setYearMonth(`${month?.month} ${year?.year}`);
    togglePicker();
  };

  const years = Array.from({ length: 100 }, (_, i) =>
    (new Date().getFullYear() - 50 + i).toString(),
  );

  useEffect(() => {
    if (yearMonthvalue) {
      const [monthName, yearStr] = yearMonthvalue.split(" ");
      if (monthName && yearStr) {
        setMonth({ month: monthName });
        setYear({ year: yearStr });
      } else {
        setMonth({ month: currentMonthName });
        setYear({ year: currentYear });
      }
    } else {
      setMonth({ month: currentMonthName });
      setYear({ year: currentYear });
    }
  }, [yearMonthvalue, currentMonthName, currentYear]);

  return (
    <div className="relative">
      {monthRangeShow ? (
        <div onClick={togglePicker}>{monthRangeShow}</div>
      ) : (
        <div className="relative">
          <label className={`text-black-softlight text-[12px] font-semibold`}>
            {label}
          </label>
          <input
            onClick={togglePicker}
            placeholder="Select month"
            readOnly
            type="text"
            value={yearMonthvalue}
            className={`fbinput ${label && "mt-2"} text-[12px] font-semibold text-[#999] cursor-pointer w-full focus:outline-none px-3`}
          />
          <svg
            className={`h-5 w-5 absolute right-3  ${label ? "top-[43px]" : "top-[12px]"} text-gray-400`}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
        </div>
      )}

      {showPicker && (
        <div
          className={`rounded-md  border-gray-50 ${dropdownShow && dropdownShow} z-[100]  absolute shadow-lg w-[250px] ${dropdownHeight ? dropdownHeight : "h-[260px]"} bg-white border`}
        >
          <div className="flex items-center gap-5 ">
            <Picker
              className="w-[80px]"
              value={year}
              onChange={(value) => setYear(value as { year: string })}
              wheelMode="natural"
            >
              <Picker.Column name="year">
                {renderOptions(years, "text-blue-600")}
              </Picker.Column>
            </Picker>
            <p>:</p>
            <Picker
              className="w-[88px]"
              value={month}
              onChange={(value) => setMonth(value as { month: string })}
              wheelMode="natural"
            >
              <Picker.Column name="month">
                {renderOptions(months, "text-blue-600")}
              </Picker.Column>
            </Picker>
          </div>
          <div className="flex-center px-5">
            <button
              onClick={handleCloseModal}
              className="w-full cursor-pointer text-[12px] font-semibold text-[#999]"
            >
              Close
            </button>
            <button
              onClick={handldSetYearMonth}
              className="bg-[#2D65F2] py-[6px] rounded-md text-white text-[12px] font-semibold w-full"
            >
              Select
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
